import React from "react";

export function NoImagePlaceholderIcon() {
    return <i className="bx bx-image" style={{ fontSize: "34px" }}></i>;
}
